import * as React from 'react';
import { connect } from 'react-redux';
import { pick } from 'lodash';
import { bindActionCreators, Dispatch } from 'redux';
import a from '../../../redux/actions';
import s from '../../../redux/selectors';
import units from '../../../lib/units';
import { withT, withRouterAndHelpers, wrap } from '../../../lib/wrappers';
import { State } from '../../../redux/types';
import { Button, Panel } from 'react-bootstrap';
import CriticalAssumptions from './CriticalAssumptions';

interface Props {
  t: (key: string, options?: {[key: string]: string}) => string;
  setUnitSystem: (system: string) => void;
  isMetric: boolean;
  ui: any;
}

const Settings = ({
  t,
  setUnitSystem,
  isMetric,
  ui
}: Props) => (
  <div id="account__settings">
    <Panel className="panel-coolclimate">
      <Panel.Heading>{t('Assumption Values')}</Panel.Heading>
      <Panel.Body>
        <CriticalAssumptions />
      </Panel.Body>
    </Panel>
    <Button
      block
      role="button"
      onClick={() => setUnitSystem(isMetric ? units.STANDARD : units.METRIC)}
    >
      <img
        alt={t('Take Action')}
        src="/assets/img/ruler_icon.png"
        style={{ maxHeight: '55px' }}
      />
      {t('Switch to {{unitSystem}} units', { unitSystem: isMetric ? t('standard') : t('metric') })}
    </Button>
    {/*
      <div
        role="button"
        className=""
        onClick={() => setLocale(locale === 'fr' ? 'en' : 'fr')}
      >
        <div className="">
          <img alt={t('Take Action')} src="/assets/img/locale.png" />
        </div>
        <span>
          {locale === 'fr' ? 'English' : 'Français' }
        </span>
      </div>
    */}
  </div>
);

const mapStateToProps = (state: State, ownProps: Props) => [
  'isMetric', 'ui'
].reduce((props, selector) => ({
  ...props,
  [selector]: s[selector](state, ownProps)
}), {});

const mapDispatchToProps = (dispatch: Dispatch) => bindActionCreators(
  pick(a, [
    'setUnitSystem'
  ]),
  dispatch
);

export default wrap(
  withT('settings'),
  withRouterAndHelpers,
  connect(mapStateToProps, mapDispatchToProps),
  Settings
);
